const endPoint =
  process.env.NODE_ENV === "production" ||
    process.env.BABEL_ENV === "production"
    ? "VIP.getech.com.tw"
    : "114.34.8.167"

const endPointWs =
  process.env.NODE_ENV === "production" ||
    process.env.BABEL_ENV === "production"
    ? "VIP.getech.com.tw"
    : "114.34.8.167"

const uri = `http://${endPoint}:4000/graphql`
const webSocketUri = `ws://${endPointWs}:4000/graphql`

export { uri, webSocketUri }
